// extracted by mini-css-extract-plugin
export default {"rating":"oL-z","numberOfStars":"pL-z","count":"qL-z","barGraphSpacing":"rL-z","barGraph":"sL-z"};